import * as Yup from "yup";
import { form, AppendixForm } from "./form";

const checkout = form;
const checkoutAppendix = AppendixForm;

const {
  formField: {
    taxId,
    conpanyName,
    releaseDate,
    representative,
    creator,
    lastTime,
    taxCalculationPeriod,
    changePosition,
    sendTo,
  },
} = checkout;

const validation = Yup.object().shape({
  [conpanyName.name]: Yup.string().required(conpanyName.errorMsg),
  [sendTo.name]: Yup.string().required(sendTo.errorMsg),
  [releaseDate.name]: Yup.string().required(releaseDate.errorMsg),
  // [lastTime.name]: Yup.string().required(lastTime.errorMsg),
  // [changePosition.name]: Yup.string().required(changePosition.errorMsg),
  [taxCalculationPeriod.name]: Yup.string().required(taxCalculationPeriod.errorMsg),
  [creator.name]: Yup.string().required(creator.errorMsg),
  [representative.name]: Yup.string().required(representative.errorMsg),
  [taxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),
});

export default validation;
